export default {
    'name': 'reactions',
    'label': 'CAS.Reactions',
    'getComponent': () => import('./Reactions.vue'),
    'tabIndex': 100,
    'left': false,
    'right': false,
    'singleView': true,
    'exclusiveRoutePath': '/cas/reactions',
};
